import type { ComponentPropsWithoutRef, ReactNode } from 'react'
import cn from 'classnames'
import { Children, isValidElement } from 'react'
import styles from './List.module.css'

interface ListProps extends ComponentPropsWithoutRef<'ul'> {
  direction?: 'x' | 'y'
  spacing?: string
}

export function FooterList({ children, direction = 'y', spacing, className, ...attrs }: ListProps) {
  return (
    <ul
      className={cn(styles.list, className)}
      style={{
        flexDirection: direction === 'x' ? 'row' : 'column',
        ...(spacing && { gap: spacing }),
      }}
      {...attrs}
    >
      {wrapItemsWithList(children)}
    </ul>
  )
}

interface ItemProps extends ComponentPropsWithoutRef<'li'>, Pick<ComponentPropsWithoutRef<'a'>, 'target' | 'rel'> {
  href?: string
  title?: string
  alt?: string
}

function Item({ children, href, title, target, rel, className, ...attrs }: ItemProps) {
  if (!href) {
    return <li className={cn(styles.listItem, className)} {...attrs}>{children}</li>
  }

  return (
    <li className={cn(styles.listItem, className)} {...attrs}>
      <a className={styles.itemLink} href={href} title={title} target={target} rel={rel} aria-label={attrs.alt}>{children}</a>
    </li>
  )
}

export const FooterListItem = Item

function wrapItemsWithList(children: ReactNode | ReactNode[]) {
  return Children.map(children, (child) => {
    if (child == null) {
      return null
    }

    return isValidElement(child) ? child : null
  })
}
